<template>
  <div>
    <section class="py-5 bg-primary text-white arduino">
      <div class="container">
        <div class="">
          <swiper
            class="learn-slider"
            :slides-per-view="1"
            :space-between="50"
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false,
            }"
            :pagination="{
              clickable: true,
            }"
            :navigation="true"
            :modules="modules"
          >
            <swiper-slide v-for="slide in 6" :key="slide">
              <div class="row">
                <div class="col-lg-5 col-12 d-flex align-items-center mb-3">
                  <div>
                    <h4>Our Arduino Kit</h4>
                    <p class="mb-3">
                      Amet minim mollit non deserunt ullamco est sit aliqua
                      dolor do amet sint. Amet minim mollit non deserunt ullamco
                      est sit aliqua dolor do amet sint, amet minim mollit non
                      deserunt ullamco est sit aliqua dolor do amet sint.
                    </p>
                    <p>
                      Amet minim mollit non deserunt ullamco est sit aliqua
                      dolor do amet sint. Amet minim mollit non deserunt ullamco
                      est sit aliqua dolor do amet sint, amet minim mollit non
                      deserunt ullamco est sit aliqua dolor do amet sint.
                    </p>
                    <p>
                      Amet minim mollit non deserunt ullamco est sit aliqua
                      dolor do amet sint, amet minim mollit non deserunt ullamco
                      est sit
                    </p>
                    <router-link to="#" class="btn btn-outline-light"
                      >Read More</router-link
                    >
                  </div>
                </div>
                <div class="col-lg-7 col-12 mb-3">
                  <div class="h-100">
                    <div class="row mb-2">
                        <div class="col-md-6 mx-0 px-1">
                            <img src="../../assets/Images/home/arduino-1.png" class="img-fluid" alt="">
                        </div>
                        <div class="col-md-6 mx-0 px-1">
                            <img src="../../assets/Images/home/arduino-2.png" class="img-fluid" alt="">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-6 mx-0 px-1 mb-3">
                            <img src="../../assets/Images/home/arduino-3.png" class="img-fluid" alt="">
                        </div>
                        <div class="col-md-4 col-6 mx-0 px-1 mb-3">
                            <img src="../../assets/Images/home/arduino-4.png" class="img-fluid" alt="">
                        </div>
                        <div class="col-md-4 col-12 mx-0 px-1 mb-3">
                            <img src="../../assets/Images/home/arduino-5.png" class="img-fluid" alt="">
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>
    <section>
      <div class="d-flex justify-content-center align-items-center showcase text-white">
        <div class="showcase-content text-center">
          <h3 class="mb-3">
            In need of skilled individuals to work on a project?
          </h3>
          <div class="d-flex justify-content-center align-items-center">
            <router-link to="#" class="btn btn-outline-light"
              >Read More</router-link
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper";
export default {
  name: "Arduino",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {};
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
  
  <style scoped>
.learn-slider {
  width: 70% !important;
  margin: 0 auto;
}

.learn-image {
  height: 400px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #ffffff;
  font-size: 30px;
  z-index: 900;
  color: white !important;
}

.swiper-button-next {
  right: 0px !important;
}

.swiper-button-prev {
  left: 0px !important;
}


.swiper {
  padding: 0 40px;
}

.showcase {
  height: 360px;
  background-image: url("../../assets/Images/knowus.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-blend-mode: darken;
  background-color: rgba(0, 0, 0, 0.1);
}

.showcase-content {
    width: 50%;
}

@media (max-width: 769px) {
  .learn-slider {
    width: 100% !important;
  }

  .showcase-content {
    width: 85%;
  }
}
</style>